class HelperList {
  static hasSomeEqualValue(list: any, source: any): boolean {
    let response = false

    source.forEach((bl: any) => {
      list?.forEach((l: any) => {
        if (l?.includes(bl)) response = true
      })
    })
    return response
  }

  static transformEmptyListInNull(list: any) {
    if (list.length === 0) return null
    return list
  }

  static formatIdDisplay(id: string) {
    const places = 4
    const zero = places - id.length + 1
    return Array(+(zero > 0 && zero)).join('0') + id
  }
}

export default HelperList
